import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Drawer from '@material-ui/core/Drawer';

const drawerWidth = 300;

const useStyles = makeStyles((theme) => ({
   drawer: {
      width: drawerWidth,
      flexShrink: 0,
      whiteSpace: 'nowrap',
      [theme.breakpoints.up('lg')]: {
         marginTop: 64,
         height: 'calc(100% - 64px)'
      }
   },
   drawerOpen: {
      width: drawerWidth,
      transition: theme.transitions.create('width', {
         easing: theme.transitions.easing.sharp,
         duration: theme.transitions.duration.enteringScreen
      })
   },
   drawerClose: {
      transition: theme.transitions.create('width', {
         easing: theme.transitions.easing.sharp,
         duration: theme.transitions.duration.leavingScreen
      }),
      overflowX: 'hidden',
      width: theme.spacing(7) + 1,
      [theme.breakpoints.up('sm')]: {
         width: theme.spacing(9) + 1
      }
   },
   root: {
      backgroundColor: theme.palette.white,
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      padding: theme.spacing(1)
   }
}));
/**
 * Barra lateral temporal simple que mostrara el contenido envuelto por este componente.
 *
 * Cualquier otra propiedad no especificada en la documentacion sera reenviada al componente [Drawer](https://material-ui.com/api/drawer/).
 */
function Sidebar({
   open,
   variant,
   onClose,
   className,
   children,
   keepMounted,
   disableBackdropClick,
   disableEscapeKeyDown,
   ...rest
}) {
   const classes = useStyles();
   function handleOnClose(e, reason) {
      if (disableBackdropClick && reason === 'backdropClick') {
         return false;
      }

      if (disableEscapeKeyDown && reason === 'escapeKeyDown') {
         return false;
      }

      if (typeof onClose === 'function') {
         onClose(e, reason);
      }
   }

   return (
      <Drawer
         classes={{
            paper: clsx(classes.drawer, {
               [classes.drawerOpen]: open,
               [classes.drawerClose]: !open
            })
         }}
         onClose={handleOnClose}
         open={open}
         variant={variant}
         ModalProps={{
            BackdropProps: {
               invisible: true
            },
            keepMounted
         }}
         {...rest}
      >
         <div
            className={clsx(classes.root, {
               //[classes.drawerOpen]: open,
               //[classes.drawerClose]: !open
            })}
         >
            {children}
         </div>
      </Drawer>
   );
}

Sidebar.propTypes = {
   /**
    * Si es __true__ la barra lateral sera visible.
    */
   open: PropTypes.bool.isRequired,
   /**
    * Funcion a ejecutar cuando se desea cerrar/ocultar la barra lateral. Generalmen usado para modificar `open` a __false__.
    */
   onClose: PropTypes.func,
   /**
    * Si es ___true__, mantendra los componentes en el DOM.
    */
   keepMounted: PropTypes.bool,
   /**
    * Variante de Material-UI a usar.
    */
   variant: PropTypes.oneOf(['permanent', 'persistent', 'temporary']),
   /**
    * Si es __true__ no se ejecutara el callback `onClose` cuando se haga click fuera del modal.
    */
   disableBackdropClick: PropTypes.bool,
   /**
    * Si es __true__ no se ejecutara el callback `onClose` cuando se presione la tecla *escape*.
    */
   disableEscapeKeyDown: PropTypes.bool
};

Sidebar.defaultProps = {
   keepMounted: false,
   default: 'temporary',
   disableBackdropClick: false,
   disableEscapeKeyDown: false
};

export default Sidebar;
